import React, { FC, useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import { useParams, useHistory } from "react-router-dom";
import Heading2 from "components/Heading/Heading2";
import { AuthContext } from "context/authenticate";
import { getNameByLang } from "utils/util";


export interface CarouselProps {
    className?: string;
};

const ProductTypeComponent: FC<CarouselProps> = ({ className = "" }) => {
    const history = useHistory();
    const { t } = useTranslation();
    const { productTypeList } = useContext(AuthContext);
    const { language } = i18n;


    const onItemClick = (item: any) => {
        history.push(`/category/${item.id}`);
    };
    return (
        <div className="max-w-[1080px] mx-auto mt-8 sm:mt-8 lg:mt-16">
            <Heading2 heading={t('product.type_title')} />
            <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4 lg:gap-8">
                {
                    productTypeList.map(item => (
                        <div key={item.id} className="flex flex-col items-center cursor-pointer" onClick={() => onItemClick(item)}>
                            <img src={item.pictureUrl} alt={item.id} className="w-full max-w-[300px] lg:max-w-none aspect-square object-cover" />
                            <div className="text-[16px] text-[#000] mt-[16px] text-center">{item[getNameByLang(language)]}</div>
                        </div>
                    ))
                }
            </div>

        </div>
    )
};

export default ProductTypeComponent;